"use strict";

exports.__esModule = true;
exports.default = void 0;
var _index = require("../../../swcp-base/js/index");
var _actions = _interopRequireDefault(require("./actions"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const entity = {
  singular: 'tag',
  plural: 'tags',
  title: 'Tags',
  icon: 'VDC_IconFont_CP_Tags',
  secondaryMenu: ['list', 'create', 'import', 'single', 'edit'],
  singleTitle: props => `Tag ${props.tag.data.Name}`
};
const routes = (0, _index.RoutesFactory)(entity, _actions.default);
var _default = exports.default = routes;
module.exports = exports.default;